import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
    console.warn(
        '⚠️  Supabase credentials chybí. Doplň VITE_SUPABASE_URL a VITE_SUPABASE_ANON_KEY do .env.local'
    );
}

// Veřejný web nemá přihlašování — vystačí si s anonymním klíčem bez session.
export const supabase = createClient(url || 'https://placeholder.supabase.co', key || 'placeholder', {
    auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false
    }
});

export const hasSupabaseConfig = Boolean(url && key);

// Veřejná URL souboru z bucketu web-media.
export function mediaUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//.test(path)) return path;
    return supabase.storage.from('web-media').getPublicUrl(path).data.publicUrl;
}
